import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAppBar,{staticClass:"grey darken-1",attrs:{"app":"","dark":""}},[_c(VAppBarNavIcon,{on:{"click":_vm.toggleNavigationBar}}),_c(VToolbarTitle,[_c('span',{staticClass:"font-weight-bold font-weight-black title text-uppercase"},[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"flex-grow-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }